import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import Loader from '../components/Loader';
import Dropzone from 'react-dropzone'
import Clipboard from 'clipboard';
import ReactDOM from 'react-dom';

class UploadFile extends Component {

    constructor(props) {
        super(props);
        const { location } = props;

        this.state = {
            dropzoneActive: false,
            dropzoneUploading: false,
            fileUrl: undefined,
            copied: false
        };
    }

    componentWillMount(){
        window.addEventListener("message", (e) =>{
            console.log(e.data);
            console.log("received message");
        });
    }

    componentDidMount() {    
        new Clipboard('.copy-to-clipboard');
    }

    onDragEnter = () => {

        this.setState({
          dropzoneActive: true
        });
    }
    
    onDragLeave = () => {
        this.setState({
            dropzoneActive: false
        });
    }

    onDrop = (file) => {

        if(file && file.length > 0){
          this.setState({
            dropzoneUploading: true
          });
    
          var formData = new FormData();
          formData.append('image', file[0]);
          api('api/file/upload', {
            method: 'POST',
            body: formData
          }).then(data => {

            console.log('upload result', data)
            this.setState({
                fileUrl: data.file_short_url
            });

            // this.handleOnFileUploadSuccess(data)
          }).catch(err =>{
            // this.handleOnFileUploadError(err)
          }).then(() => {
            this.setState({
              dropzoneUploading: false,
              dropzoneActive: false
            });
          })
        } else {
          this.setState({
            dropzoneActive: false
          });
        }
    }

    onCopyClicked = () => {
        this.setState({
            copied: true
        });
    }

    // handleOnFileUploadSuccess = (data) => {
    //     const { showModal, setModalData } = this.props
    //     const { addCartItems, clearCart, addError } = this.props;
    //     if(data.missing_articles.length){
    //       clearCart();
    //       showModal();
    //       setModalData(data.missing_articles, data.file_short_url)
    //     } else if (data && data.items && data.items.length) {
    //       clearCart();
    //       addCartItems(data.items, data.file_short_url)
    //     } else {
    //       addError("Failed to load item list from file");
    //     }
    //   }
    
    // handleOnFileUploadError = (err) => {
    //     const { addError } = this.props;
    //     addError(err);
    // }

    copyFileUrl = () => {
        /* Get the text field */
        var copyText = document.getElementById("myInput");
      
        /* Select the text field */
        copyText.select();
      
        /* Copy the text inside the text field */
        document.execCommand("Copy");
      
        /* Alert the copied text */
        alert("Copied the text: " + copyText.value);
    }
    

    render() {
        const { error } = this.props
        const { dropzoneActive, dropzoneUploading, fileUrl, copied } = this.state
    
        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 file-upload-wrapper">
                            { fileUrl && 
                                <div>
                                    <label className='file-upload-title' style={{color: "#3c763d"}}>Upload Success</label>
                                    <span><a target="_blank">{fileUrl}</a></span>
                                    <button className="copy-to-clipboard" onClick={this.onCopyClicked} data-clipboard-text={fileUrl}>{copied ? "Copied" : "Copy"}</button>
                                    <p>Copy and paste the URL above to the field below ↓</p>
                                </div>
                            }

                            { !fileUrl && 
                                <Dropzone
                                    style={{}}
                                    multiple={false}
                                    accept='image/*'
                                    onDrop={this.onDrop}
                                    onDragEnter={this.onDragEnter}
                                    onDragLeave={this.onDragLeave}>
                                    { dropzoneActive && <div className='fileupload-dropzone-overlay'>{ dropzoneUploading ? `Uploading...` : `Drop your image here...`}</div> }
                                    <div>
                                        <label className='file-upload-title'>Drop your file here. </label>
                                        <button disabled={dropzoneUploading}>{dropzoneUploading ? "Uploading" : "Upload Image"}</button>
                                        <p>Accepted image *.jpeg and *.png only</p> 
                                    </div>
                                </Dropzone>
                            }
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {
        
    };
})(UploadFile);